module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalelectricians.com.au/images/splash-5dba0e00239d2fc2f95a3c96096d1bd9.jpeg";